import _ from 'lodash';
import FileSaver from 'file-saver';

/**
 * Save a string as a text file
 *
 * @param text
 * @param filename
 */
export const saveTextFile = (text, filename) => {
  const blob = new Blob([text], {type: 'text/plain;charset=utf-8"'});
  FileSaver.saveAs(blob, filename || 'download.txt', true);
}

/**
 * Creates a string representation of a csv file, ready to be saved.
 *
 * Function expects data to create rows from, and headers to match to the data if
 * supplied. If no headerArray is provided, one is generated using the keys of the first
 * object in the data collection.
 *
 * A rowIteree function may be defined, which is used to generate an array representation
 * of each row that should match the length and order of the header array.
 * The iteree will be called once for each item in the data collection. If nothing is returned,
 * that row is skipped.
 *
 * If no iteree is provided, the default assumes the headers match properties of each item
 * in the data collection, and the header values will be used to extract the row values at those
 * properties.
 *
 * @param data - collection used to create rows
 * @param headerArray - optional array of string
 * @param rowIteratee
 * @returns {string}
 */
export const createCsv = (data, headerArray, rowIteratee) => {

  // Create headers from array object keys if not defined
  var headers = headerArray || _.keysIn(_.first(data));

  // Create Iterator function if not provided for header properties
  rowIteratee = rowIteratee || function (item) {
    return _.map(headers, function (header) {
      return item[header] || '';
    });
  };

  // Create headers row in csv text
  var csv = headers.join(',') + '\n';

  // Loop through data to create rows array of arrays
  var rowContents = _.map(data, rowIteratee);

  // Push values out with commas and new line
  _.forEach(rowContents, function (rowArray) {
    if (rowArray && rowArray.length) {
      rowArray = _.map(rowArray, function (item) {
        return _.isNumber(item) ? item : ('"' + item + '"');
      });

      csv += rowArray.join(',') + '\n';
    }
  });

  return csv;
};


// WEBPACK FOOTER //
// ./src/utils/file-utils.js